import { Component, Inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from "@angular/material/snack-bar";

@Component({
    selector: "app-snackbar-success",
    templateUrl: "./snackbar-success.component.html",
    styleUrls: ["./snackbar-success.component.scss"],
    imports: [MatIconModule]
})
export class SnackbarSuccessComponent {
  iconName = "check_circle";

  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarSuccessComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data?: any
  ) {
    if (data?.type === "ErrorMessage") {
      this.iconName = "error_outline";
    } else if (data?.action === "Informational") {
      this.iconName = "info";
    }
  }
}
